import { ZoneConnectionResponseDTO } from '@/core/api/dtos/response/zone/zoneConnection'
import { ZoneConnection } from '@/core/api/entities/zone/zoneConnection'

export class ZoneConnectionMapper {
	static toEntity(dto: ZoneConnectionResponseDTO): ZoneConnection {
		return ZoneConnection.create(dto)
	}

	static toEntities(dtos: ZoneConnectionResponseDTO[]): ZoneConnection[] {
		return dtos.map(this.toEntity)
	}
}
